<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari nama pengguna, voucher, atau kode&hellip;"
                 aria-label="Cari langganan voucher" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter tipe"
                  (change)="isType = $event.target.value; applyFilter()">
            <option value="">Semua tipe</option>
            <option value="0">Unik</option>
            <option value="1">Masal</option>
          </select>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Pengguna</th>
                  <th>Voucher</th>
                  <th>Kode</th>
                  <th>Tipe</th>
                  <th class="text-center">Masa Aktif</th>
                  <th>Mulai</th>
                  <th>Berakhir</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let v of isData; let i = index" class="vl-row" [class.vl-alt]="i % 2 == 1">
                  <th class="vl-num">{{rowNo(i)}}</th>
                  <td><span class="vl-name" [innerHTML]="highlight(v.userName)"></span></td>
                  <td><span [innerHTML]="highlight(v.voucher.name)"></span></td>
                  <td>
                    <span class="vl-code-wrap">
                      <code class="vl-code" [innerHTML]="highlight(v.voucher.code)"></code>
                      <button type="button" class="vl-copy" title="Salin kode" (click)="copyCode(v.voucher.code)">
                        <i class="fa fa-copy"></i></button>
                    </span>
                  </td>
                  <td>
                    <span *ngIf="v.voucher.type == 0" class="vl-tag unik">Unik</span>
                    <span *ngIf="v.voucher.type == 1" class="vl-tag masal">Masal</span>
                    <span *ngIf="v.voucher.type == null" class="vl-muted">&mdash;</span>
                  </td>
                  <td class="text-center">{{v.voucher.expired_day}} hari</td>
                  <td class="vl-muted vl-small">{{v.createdVw}}</td>
                  <td class="vl-muted vl-small">{{v.expiredVw}}</td>
                  <td>
                    <span *ngIf="v.isActive" class="vl-pill on"><span class="vl-dot"></span>Aktif</span>
                    <span *ngIf="!v.isActive" class="vl-pill off"><span class="vl-dot"></span>Berakhir</span>
                  </td>
                </tr>
                <tr *ngIf="!isData.length">
                  <td colspan="9" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> langganan</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
